import { useState } from "react";
import { Plus } from "lucide-react";
import { SIZE_ORDER, SIZE_LABELS } from "@/data/menu";

const formatBRL = (v) => v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const PizzaCard = ({ item, categoryId, onRequestAdd }) => {
  const [size, setSize] = useState("8f");
  const price = item.prices[size];
  const testIdBase = `${categoryId}-${item.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;

  const isDoce = item.flavorType === "doce";

  return (
    <article
      className="rounded-2xl border border-zinc-800/80 bg-zinc-900/60 overflow-hidden animate-fade-up"
      data-testid={`pizza-card-${testIdBase}`}
    >
      <div className="flex gap-3 p-3">
        <div className="relative w-24 h-24 shrink-0 rounded-xl overflow-hidden bg-zinc-800">
          <img src={item.image} alt={item.name} loading="lazy" className="w-full h-full object-cover" />
          <div className="absolute inset-0 ring-1 ring-inset ring-white/5 rounded-xl" />
        </div>
        <div className="min-w-0 flex-1">
          <h3 className="font-display text-[17px] leading-tight text-zinc-50 truncate">{item.name}</h3>
          <p className="text-[12px] text-zinc-400 mt-1 leading-snug line-clamp-2">{item.description}</p>
          <div className="mt-2 flex items-baseline gap-2">
            <span className="text-rose-500 font-bold text-lg tracking-tight" data-testid={`${testIdBase}-price`}>
              {formatBRL(price)}
            </span>
            <span className="text-[10px] uppercase tracking-widest text-zinc-500">{SIZE_LABELS[size]}</span>
          </div>
        </div>
      </div>

      <div className="px-3 pb-3">
        <div className="flex gap-1.5 overflow-x-auto no-scrollbar" data-testid={`${testIdBase}-size-picker`}>
          {SIZE_ORDER.map((s) => {
            const active = s === size;
            return (
              <button
                key={s}
                type="button"
                onClick={() => setSize(s)}
                data-testid={`${testIdBase}-size-${s}`}
                className={`press shrink-0 text-[11px] font-semibold px-3 py-1.5 rounded-full border transition-colors ${
                  active
                    ? "bg-rose-600 border-rose-600 text-white"
                    : "bg-zinc-950/60 border-zinc-800 text-zinc-400"
                }`}
              >
                {SIZE_LABELS[s]}
              </button>
            );
          })}
        </div>

        <button
          type="button"
          onClick={() =>
            onRequestAdd({
              item,
              categoryId,
              initialSize: size,
              isDoce,
              basePrice: item.prices[size],
              getPriceForSize: (s) => item.prices[s],
            })
          }
          data-testid={`${testIdBase}-add-btn`}
          className="press mt-3 w-full flex items-center justify-center gap-2 bg-gradient-to-b from-rose-500 to-rose-600 text-white font-semibold text-sm py-2.5 rounded-xl shadow-[0_6px_20px_-8px_rgba(244,63,94,0.6)]"
        >
          <Plus className="w-4 h-4" strokeWidth={2.8} />
          Adicionar ao Pedido
        </button>
      </div>
    </article>
  );
};

export const BeverageCard = ({ item, categoryId, onAddBeverage }) => {
  const testIdBase = `${categoryId}-${item.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;
  return (
    <article
      className="rounded-2xl border border-zinc-800/80 bg-zinc-900/60 overflow-hidden flex gap-3 p-3 animate-fade-up"
      data-testid={`beverage-card-${testIdBase}`}
    >
      <div className="w-20 h-20 shrink-0 rounded-xl overflow-hidden bg-zinc-800">
        <img src={item.image} alt={item.name} loading="lazy" className="w-full h-full object-cover" />
      </div>
      <div className="min-w-0 flex-1 flex flex-col">
        <h3 className="font-display text-[16px] leading-tight text-zinc-50">{item.name}</h3>
        <p className="text-[12px] text-zinc-400 mt-1">{item.description}</p>
        <div className="mt-auto flex items-center justify-between pt-2">
          <span className="text-rose-500 font-bold" data-testid={`${testIdBase}-price`}>
            {formatBRL(item.price)}
          </span>
          <button
            type="button"
            onClick={() => onAddBeverage({ item, categoryId })}
            data-testid={`${testIdBase}-add-btn`}
            className="press flex items-center gap-1.5 bg-rose-600 text-white text-xs font-semibold px-3 py-2 rounded-full"
          >
            <Plus className="w-3.5 h-3.5" strokeWidth={2.8} />
            Adicionar
          </button>
        </div>
      </div>
    </article>
  );
};
